import { render, staticRenderFns } from "./pondTransfer.vue?vue&type=template&id=e596cf40&scoped=true&"
import script from "./pondTransfer.vue?vue&type=script&lang=js&"
export * from "./pondTransfer.vue?vue&type=script&lang=js&"
import style0 from "./pondTransfer.vue?vue&type=style&index=0&id=e596cf40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e596cf40",
  null
  
)

export default component.exports